import { computed, watch } from 'vue';

import { setSupportRequester, type SupportRequester } from '@/services/zendesk-widget';
import { useApplicationStore } from '@/stores/Application';
import { useAuthStore } from '@/stores/Auth';
import { useUserStore } from '@/stores/User';

/**
 * The support widget's forms follow the signed-in member: their name and email are filled in on sign-in and emptied on
 * sign-out (zendesk-widget.ts). App.vue holds it for the app's lifetime. Not while an admin is signed in as a member:
 * a ticket sent from there would be filed as the member.
 */
export function useSupportRequester(): void {
    const authStore = useAuthStore();
    const userStore = useUserStore();
    const appStore = useApplicationStore();

    const requester = computed< SupportRequester | null >( () => {
        if ( !authStore.isAuthenticated || appStore.isAdminSession() ) return null;

        const profile = userStore.user;
        const name = [ profile?.firstName, profile?.lastName ].map( part => part?.trim() ).filter( Boolean ).join( ' ' );
        const email = profile?.email?.trim() ?? '';
        return name || email ? { name, email } : null;
    } );

    watch( requester, member => setSupportRequester( member ), { immediate: true } );
}
